// extracted by mini-css-extract-plugin
module.exports = {"nprogress-spinner":"styles_nprogress-spinner__1R2zr"};